import { QlfConfirmDialogProps } from '@qualifio/ui-commons';
import { useCallback, useState } from 'react';

export type UseDialogCallback = () => void;

export interface UseConfirmDialogResult {
  props: any;
  setProps: (props: any) => void;
  onConfirm: QlfConfirmDialogProps['onConfirm'];
  onClose: QlfConfirmDialogProps['onClose'];
  open: QlfConfirmDialogProps['open'];
  askConfirmation: (onConfirm: UseDialogCallback, onCancel?: UseDialogCallback) => void;
  closeDialog: () => void;
}

export function useConfirmDialog(): UseConfirmDialogResult {
  const [open, setOpen] = useState(false);
  const [onConfirm, setOnConfirm] = useState<UseDialogCallback | undefined>();
  const [onClose, setOnClose] = useState<UseDialogCallback | undefined>();
  const [props, setProps] = useState(undefined);

  const askConfirmation = (onConfirm: UseDialogCallback, onClose?: UseDialogCallback) => {
    setOnConfirm(() => onConfirm);
    setOnClose(() => onClose);
    setOpen(true);
  };

  const closeDialog = () => setOpen(false);

  const handleClose = useCallback(() => {
    onClose?.();
    setOpen(false);
  }, [onClose]);

  const handleConfirm = useCallback(() => {
    onConfirm?.();
    setOpen(false);
  }, [onConfirm]);

  return {
    props,
    setProps,
    askConfirmation,
    closeDialog,
    onConfirm: handleConfirm,
    onClose: handleClose,
    open,
  };
}
